import * as Yup from "yup";

const TableNumberSchema = Yup.object().shape({
  TableNumber: Yup.string().required("Table Number is required"),
});

export default TableNumberSchema;
